module.exports = __webpack_public_path__ + "img/sys.a08cf686.svg";